import hostList from "./api_host.js?a=1026";

const WEB_HOST = hostList.WEB_HOST;

//web
const BASE_URL = WEB_HOST + "/Ant_OW_API/api";

//econtract
const Econtract_URL = WEB_HOST + "/Ant_EC_API/api";

//APP
const App_URL = WEB_HOST + "/Ant_OW_API/app";

//outside
const Outside_URL = WEB_HOST + "/Ant_OW_API/outside";

const WebApiUrl = {
  // https://anshinescrow-dev.januarytc.com/Ant_EC_API/Api/API-Schedul-UpdateStatus
  WEB_HOST: WEB_HOST,
  // 保證書套印檔案下載
  clientGuarantee: BASE_URL + "/API-WarrantyOverprint-Download",
  //電子合約 電子謄本
  APIPdfToTxt: Econtract_URL + "/API-PdfToTxt",
  //電子合約 雲端同步
  APISchedulUpdateStatus: Econtract_URL + "/API-Schedul-UpdateStatus",

  //業績分配表匯出pdf
  getperformancepdf: Outside_URL + "/api-getperformancepdf",

  //OTP RESET
  resetaccountotpcount: App_URL + "/api-resetaccount-otp-count",

  //econtract
  econtractOverprint: Econtract_URL + "/API-Old-ContractOverprint",
  getContractId: Econtract_URL + "/API-Old-GetContractId",
  getcontracttype:
    Econtract_URL + "/API-Old-GetContractDataWithWriteLegal-List",

  econtractadd: Econtract_URL + "/API-Main-Add",
  econtractsave: Econtract_URL + "/API-Main-Archive",
  econtractedit: Econtract_URL + "/API-Main-EditInfo",
  econtractlist: Econtract_URL + "/API-Main-List",
  econtractdel: Econtract_URL + "/API-Main-Del",

  econtractgetcity: Econtract_URL + "/API-Old-NPUCity-List",
  econtractgetarea: Econtract_URL + "/API-Old-NPUTown-List",
  econtractgetroad: Econtract_URL + "/API-Old-NPURoad-List",
  econtractgetsec: Econtract_URL + "/API-Old-NPUSecData-List",
  econtractgetsubsec: Econtract_URL + "/API-Old-NPUSubSecData-List",

  econtractgetbrand: Econtract_URL + "/API-Old-NPUBrandData-List",
  econtractgetstore: Econtract_URL + "/API-Old-NPUBrandStore-List",

  econtractgetOthMatter: Econtract_URL + "/API-OthMatter-List",
  econtractaddOthMatter: Econtract_URL + "/API-OthMatter-Add",
  econtracteditOthMatter: Econtract_URL + "/API-OthMatter-Edit",
  econtractdelOthMatter: Econtract_URL + "/API-OthMatter-Del",

  // 取得 仲介分店/代書事務所列表
  getbranchlist: App_URL + "/api-getbranchlist",

  // 發送OTP 給新註冊的手機
  sendotpcode: Outside_URL + "/api-send-otp-code",
  // 修改密碼
  editpassword: Outside_URL + "/api-editpassword",

  // 未登入 發送OTP簡訊驗證
  sendotplogin: App_URL + "/api-send-otp-login",
  // 驗證OTP
  verifyotp: Outside_URL + "/api-verify-otp",
  //使用者分店/事務所關聯修改
  branchrebind: Outside_URL + "/api-branch-rebind",

  // 前台常見問題資料
  QuestionAllFront: BASE_URL + "/API-Question-All-Front",
  // 前台表單下載資料
  formdownloadallfront: BASE_URL + "/api-formdownload-all-front",
  // 前台公告資訊資料
  announceinfoallfront: BASE_URL + "/api-announceinfo-all-front",

  //資金明細-收出款查詢 （列表）
  fundtrack: Outside_URL + "/api-fundtrack",
  //資金明細-仲介服務費 （列表）
  agencyservicefee: Outside_URL + "/api-agencyservicefee",

  //抓取品牌清單 (從代書分店關聯)
  getbrandlist: Outside_URL + "/api-getbrandlist",

  //抓取住商清單(從品牌) 僅給代書使用
  getbanksumisholist: Outside_URL + "/api-getbanksumisholist",
  // 取得 仲介分店/代書 店東名稱列表
  getbranchusernamelist: App_URL + "/api-getbranchusernamelist",

  // 案件查詢列表 (專戶交易資訊) (List)
  casesearch: App_URL + "/api-casesearch",
  // 案件查詢明細 (viewModel)
  casesearchdetail: App_URL + "/api-casesearchdetail",

  // 發票查詢
  searchinvoice: Outside_URL + "/api-searchinvoice",
  // 發票查詢PDF
  GetInvoicePdf: Outside_URL + "/API-GetInvoicePdf",

  // 取得代書庫存列表 (List)
  GetWriteLegalStock: App_URL + "/api-getwritelegalstock",

  // 取得 User承辦區域代書清單 (業務系統用)
  GetUserAreaList: App_URL + "/api-getuserarealist",

  // 使用者設定列表
  getUserPageList: BASE_URL + "/API-User-Info-List",
  // 使用者明細資料
  getUserDetail: BASE_URL + "/API-User-Info",

  userEdit: BASE_URL + "/API-User-Edit",
  userAdd: BASE_URL + "/API-User-Add",

  // 群組列表
  groupList: BASE_URL + "/API-Group-Info-List",
  // 修改群組資料
  groupEdit: BASE_URL + "/API-Group-Edit",
  // 新增群組資料
  groupAdd: BASE_URL + "/API-Group-Add",
  // 刪除群組資料
  groupDelete: BASE_URL + "/API-Group-Delete",
  //群組設定起始資料
  groupProgDefault: BASE_URL + "/API-GroupProg-Default",
  // 取得群組現有權限資料
  groupProgDetail: BASE_URL + "/API-GroupProg-Detail",
  // 群組設定資料存檔
  groupProgSetting: BASE_URL + "/API-GroupProg-Setting",

  WEB_HOST: WEB_HOST,
  login: BASE_URL + "/API-CDT-Login",
  getPermission: BASE_URL + "/API-User-Permission",

  //聯絡我們
  GetSettingMail: BASE_URL + "/API-ContactUs-GetSettingMail",
  SettingMail: BASE_URL + "/API-ContactUs-SettingMail",
  ContactUsList: BASE_URL + "/API-ContactUs-List",
  ContactUsUpdateMsg: BASE_URL + "/API-ContactUs-UpdateMsg",

  //友站連結 機關團體
  WeblinkCategory: BASE_URL + "/API-Useful-Links-Category",
  WeblinkCategoryAdd: BASE_URL + "/API-Useful-Links-Add",
  WeblinkCategoryModify: BASE_URL + "/API-Useful-Links-Modify",
  WeblinkCategoryDel: BASE_URL + "/API-Useful-Links-Del",
  WeblinkDetails: BASE_URL + "/API-Useful-Links-Details",
  WeblinkDetailsAdd: BASE_URL + "/API-Useful-Links-Details-Add",
  WeblinkDetailsModify: BASE_URL + "/API-Useful-Links-Details-Modify",
  WeblinkDetailsDel: BASE_URL + "/API-Useful-Links-Details-Del",

  //表單下載
  FileCategorySpc: BASE_URL + "/API-FormDownload-Category-Spc",
  FileCategory: BASE_URL + "/API-FormDownload-Category",
  FileDetail: BASE_URL + "/API-FormDownload-Details-List",
  FileDetailAdd: BASE_URL + "/API-FormDownload-Details-Add",
  FileDetailModify: BASE_URL + "/API-FormDownload-Details-Modify",
  FileDetailDel: BASE_URL + "/API-FormDownload-Details-Del",

  //據點查詢
  Stronghold: BASE_URL + "/API-Stronghold-List",
  StrongholdAdd: BASE_URL + "/API-Stronghold-Add",
  StrongholdModify: BASE_URL + "/API-Stronghold-Modify",
  StrongholdDel: BASE_URL + "/API-Stronghold-Del",

  //友商廣告
  Advertise: BASE_URL + "/API-Advertise-List",
  AdvertiseAdd: BASE_URL + "/API-Advertise-Add",
  AdvertiseModify: BASE_URL + "/API-Advertise-Modify",
  AdvertiseDel: BASE_URL + "/API-Advertise-Del",
  AdvertiseSortModify: BASE_URL + "/API-Advertise-SortModify",

  //首頁圖片
  HomeAdvertise: BASE_URL + "/API-HomeAdvertise-List",
  HomeAdvertiseAdd: BASE_URL + "/API-HomeAdvertise-Add",
  HomeAdvertiseModify: BASE_URL + "/API-HomeAdvertise-Modify",
  HomeAdvertiseDel: BASE_URL + "/API-HomeAdvertise-Del",
  HomeAdvertiseSortModify: BASE_URL + "/API-HomeAdvertise-SortModify",

  //公告
  GetFileId: BASE_URL + "/API-GetFileId",
  AnnounceInfoUploadFile: BASE_URL + "/API-AnnounceInfo-UploadFile",

  AnnounceInfoCategory: BASE_URL + "/API-AnnounceInfo-Category",
  AnnounceInfo: BASE_URL + "/API-AnnounceInfo-List",
  AnnounceInfoAdd: BASE_URL + "/API-AnnounceInfo-Add",
  AnnounceInfoModify: BASE_URL + "/API-AnnounceInfo-Modify",
  AnnounceInfoDel: BASE_URL + "/API-AnnounceInfo-Del",

  AnnounceInfoFileAdd: BASE_URL + "/API-AnnounceInfo-File-Add",
  AnnounceInfoFileDel: BASE_URL + "/API-AnnounceInfo-File-Del",
  AnnounceInfoFile: BASE_URL + "/API-AnnounceInfo-File-List ",

  // 常見問題
  QuestionCategoryList: BASE_URL + "/API-Question-Category-List",
  QuestionCategoryAdd: BASE_URL + "/API-Question-Category-Add",
  QuestionDetailsList: BASE_URL + "/API-Question-Details-List",
  QuestionCategoryModify: BASE_URL + "/API-Question-Category-Modify",
  QuestionCategoryDel: BASE_URL + "/API-Question-Category-Del",

  QuestionDetailsAdd: BASE_URL + "/API-Question-Details-Add",
  QuestionDetailsModify: BASE_URL + "/API-Question-Details-Modify",
  QuestionDetailsDel: BASE_URL + "/API-Question-Details-Del",
  QuestionDetailsSortModify: BASE_URL + "/API-Question-Details-SortModify",

  GetFileId: BASE_URL + "/API-GetFileId",
  // 取得App版號
  getAppVersion: App_URL + "/api-getappversion",

  //LOG紀錄
  LogList: BASE_URL + "/API-Log-List",

  // 抓取訊息發送紀錄
  GetMessageHistory: App_URL + "/api-getmessagehistory",

  // 簡訊＆推播發送預覽
  SendMessagePerview: Outside_URL + "/api-senedmessageperview",

  // 發送簡訊＆推播

  SendMessage: Outside_URL + "/api-senedmessage",
  // API LOG 紀錄
  SaveApiLogList: Outside_URL + "/savefunceionlog",

  //  取得買賣方名稱
  getContractManName: Outside_URL + "/getcontractmanname",

  // 品牌資料維護 查詢列表v
  ow_branddatamaintenancesearchlist: `${BASE_URL}/branddatamaintenance/searchlist`,

  // 仲介商資料維護 取得列表資料  / 仲介商查詢V
  ow_npu030600001: `${BASE_URL}/api-npu030600-001`,

  // 代書資料維護 取得列表資料v
  ow_npu030700getlist: `${BASE_URL}/npu030700/getlist`,




  // OTP 手機驗證下載
  // 回饋金OTP 驗證送出
  otpSendSms: `${App_URL}/api-reward-otp-send`,
  // 驗證 OTP 並取得下載連結
  otpVerifyAndDownload: `${App_URL}/api-reward-otp-verify-download`,

};

export default WebApiUrl;
